import EventBus from './events';

const GLOBAL_BUS_NAME = 'mics.events.global';

class EventBusFactory {
  constructor() {
    this.buses = {};
  }

  create(name) {
    if (this.buses[name]) {
      throw new Error(`bus with name ${ name } already exists`);
    }
    this.buses[name] = new EventBus();

    return this.get(name);
  }

  get(name) {
    return this.buses[name];
  }

  destroy(name) {
    delete this.buses[name];
  }

  global() {
    const globalBus = this.get(GLOBAL_BUS_NAME);

    if (globalBus == null) {
      return this.create(GLOBAL_BUS_NAME);
    }
    return globalBus;
  }
}

export default {
  install: (Vue) => {
    const busFactory = new EventBusFactory();
    // eslint-disable-next-line no-param-reassign
    Vue.events = busFactory;
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$events = busFactory;
  },
};
